/* MIDNIGHTSERIES — AFTER DARK | storefront behavior */
(() => {
  'use strict';
  const ms = window.MS || {};
  const root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || ms.root || '/').replace(/\/+$/, '') + '/';
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  const lang = document.documentElement.lang || 'en-FI';
  const currency = ms.currency || 'EUR';
  const format = (cents) => { try { return new Intl.NumberFormat(lang, { style: 'currency', currency }).format(Number(cents || 0) / 100); } catch (_) { return (Number(cents || 0) / 100).toFixed(2) + ' €'; } };
  const escapeHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeUrl = (url) => { try { const u = new URL(url, location.href); return ['http:', 'https:'].includes(u.protocol) ? u.href : ''; } catch (_) { return ''; } };
  const post = async (path, data) => {
    const res = await fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, credentials: 'same-origin', body: JSON.stringify(data) });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(json.description || json.message || ms.labels?.error || 'Unable to update cart');
    return json;
  };
  const getCart = async () => {
    const res = await fetch(root + 'cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart could not be loaded');
    return res.json();
  };
  const toast = (message) => {
    const el = $('#MsToast'); if (!el) return;
    el.textContent = message; el.classList.add('visible');
    clearTimeout(toast.timeout); toast.timeout = setTimeout(() => el.classList.remove('visible'), 3000);
  };
  const countNodes = $$('[data-cart-count]');
  const cartDrawer = $('#MsCartDrawer');
  const backdrop = $('.ms-cart-backdrop');
  let lastFocus = null;
  let cartBusy = false;
  let currentCart = null;

  const setCount = n => countNodes.forEach(el => { el.textContent = el.classList.contains('ms-bag-count') ? n : '(' + n + ')'; });
  const renderCart = cart => {
    currentCart = cart;
    setCount(cart.item_count);
    const sub = $('#MsCartSubtotal'); if (sub) sub.textContent = format(cart.total_price);
    const box = $('#MsCartItems'); if (!box) return;
    const discounts = $('#MsCartDiscounts');
    if (discounts) discounts.innerHTML = (cart.cart_level_discount_applications || []).map(d => '<p>' + escapeHtml(d.title) + '</p>').join('');
    if (!cart.items || cart.items.length === 0) {
      box.innerHTML = '<div class="ms-empty-cart"><div class="eyebrow">CART / 000</div><h3>' + escapeHtml(ms.labels?.empty || 'Your cart is empty') + '</h3><a class="btn btn-outline" href="' + root + '#midnight-collection">SHOP NOW ↗</a></div>';
      return;
    }
    box.innerHTML = cart.items.map((item, idx) => {
      const img = item.image ? '<img loading="lazy" src="' + escapeHtml(safeUrl(item.image)) + '" alt="' + escapeHtml(item.product_title) + '">' : '<div class="empty-photo"></div>';
      const compare = item.original_line_price > item.final_line_price ? '<s>' + format(item.original_line_price) + '</s>' : '';
      const discount = (item.line_level_discount_allocations || []).map(d => '<div class="ms-discount small">' + escapeHtml(d.discount_application.title) + ' −' + format(d.amount) + '</div>').join('');
      return '<div class="ms-drawer-line">' + img + '<div><a class="ms-drawer-title" href="' + escapeHtml(safeUrl(item.url || '/')) + '">' + escapeHtml(item.product_title) + '</a>' +
        '<div class="ms-drawer-meta">' + escapeHtml(item.variant_title === 'Default Title' ? '' : item.variant_title) + '</div>' +
        '<span class="ms-drawer-price">' + format(item.final_line_price) + ' ' + compare + '</span>' + discount +
        '<div class="ms-qty-buttons"><button type="button" data-cart-change="' + (idx + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + item.quantity + '</span><button type="button" data-cart-change="' + (idx + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button><button class="ms-remove" type="button" data-cart-change="' + (idx + 1) + '" data-qty="0">' + escapeHtml(ms.labels?.remove || 'Remove') + '</button></div></div></div>';
    }).join('');
  };
  const updateCart = async () => {
    try { const cart = await getCart(); renderCart(cart); return cart; }
    catch (e) { toast(e.message); return null; }
  };
  const openCart = async () => {
    if (!ms.drawCart) { window.location.assign(root + 'cart'); return; }
    if (!cartDrawer || !backdrop) return;
    lastFocus = document.activeElement;
    backdrop.hidden = false;
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(() => { backdrop.classList.add('open'); cartDrawer.classList.add('open'); });
    const button = $('[data-cart-close]', cartDrawer); if (button) button.focus();
    await updateCart();
  };
  const closeCart = () => {
    if (!cartDrawer || !backdrop) return;
    cartDrawer.classList.remove('open'); backdrop.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.setAttribute('inert', '');
    document.body.style.overflow = '';
    setTimeout(() => { if (!backdrop.classList.contains('open')) backdrop.hidden = true; }, 310);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  document.addEventListener('click', async e => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); openCart(); return; }
    const closer = e.target.closest('[data-cart-close]');
    if (closer) { if (closer.tagName !== 'A') { e.preventDefault(); closeCart(); } return; }
    const change = e.target.closest('[data-cart-change]');
    if (change) {
      e.preventDefault(); if (cartBusy) return;
      cartBusy = true;
      try { const cart = await post('cart/change.js', { line: Number(change.dataset.cartChange), quantity: Number(change.dataset.qty) }); renderCart(cart); }
      catch (err) { toast(err.message); await updateCart(); }
      finally { cartBusy = false; }
    }
  });

  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ajax-add]');
    if (!form) return;
    e.preventDefault();
    const id = Number($('input[name="id"]', form)?.value);
    const quantity = Number($('input[name="quantity"]', form)?.value || 1);
    if (!id || !quantity) { toast(ms.labels?.error || 'Please choose a product'); return; }
    const btn = $('[type="submit"]', form);
    const oldDisabled = btn?.disabled;
    if (btn) btn.disabled = true;
    const errorEl = $('.ms-purchase-error', form);
    if (errorEl) errorEl.hidden = true;
    try {
      await post('cart/add.js', { items: [{ id, quantity }] });
      if (ms.drawCart) await openCart();
      else window.location.assign(root + 'cart');
    } catch (err) {
      if (errorEl) { errorEl.hidden = false; errorEl.textContent = err.message; }
      else toast(err.message);
    } finally { if (btn) btn.disabled = !!oldDisabled; }
  });

  const menu = $('#MsMobileMenu');
  const menuButton = $('[data-menu-open]');
  const search = $('#MsSearchOverlay');
  const searchButton = $('[data-search-toggle]');
  const toggleMenu = (state) => {
    if (!menu || !menuButton) return;
    menu.hidden = !state;
    menuButton.setAttribute('aria-expanded', String(state));
    if (state && search) { search.hidden = true; searchButton?.setAttribute('aria-expanded', 'false'); }
  };
  const toggleSearch = (state) => {
    if (!search || !searchButton) return;
    search.hidden = !state;
    searchButton.setAttribute('aria-expanded', String(state));
    if (state) { toggleMenu(false); $('#MsSearchInput')?.focus(); }
  };
  menuButton?.addEventListener('click', () => toggleMenu(menu.hidden));
  menu?.addEventListener('click', e => { if (e.target.closest('a')) toggleMenu(false); });
  searchButton?.addEventListener('click', () => toggleSearch(search.hidden));
  $('[data-search-close]')?.addEventListener('click', () => toggleSearch(false));
  $$('[data-localization-select]').forEach(sel => sel.addEventListener('change', () => sel.closest('form')?.submit()));
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeCart(); toggleMenu(false); toggleSearch(false); }
    if (e.key === 'Tab' && cartDrawer?.classList.contains('open')) {
      const focusable = $$('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])', cartDrawer).filter(el => !el.disabled && el.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  $$('[data-gallery-thumb]').forEach(thumb => thumb.addEventListener('click', () => {
    const index = thumb.dataset.galleryThumb;
    $$('[data-gallery-frame]').forEach(f => f.classList.toggle('is-hidden', f.dataset.galleryFrame !== index));
    $$('[data-gallery-thumb]').forEach(t => { const active = t === thumb; t.classList.toggle('active', active); t.setAttribute('aria-pressed', String(active)); });
  }));

  const productRoot = $('[data-product-root]');
  if (productRoot) {
    const form = $('[data-product-form]', productRoot);
    const radios = $$('[data-pack-option]', productRoot);
    const hiddenId = $('[data-active-variant]', form);
    const hiddenQty = $('[data-active-quantity]', form);
    const displayedPrice = $('[data-product-price]', productRoot);
    const submitPrice = $('[data-submit-price]', form);
    const stickyPrice = $('[data-sticky-price]');
    const select = $('[data-variant-select]', form);
    const setPack = () => {
      const selected = radios.find(r => r.checked) || radios[0]; if (!selected) return;
      radios.forEach(r => r.closest('.ms-pack-option')?.classList.toggle('is-selected', r === selected));
      if (hiddenId) hiddenId.value = selected.dataset.variantId;
      if (hiddenQty) hiddenQty.value = selected.dataset.quantity || '1';
      const price = format(selected.dataset.price);
      if (displayedPrice) displayedPrice.textContent = price;
      if (submitPrice) submitPrice.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
    };
    radios.forEach(r => r.addEventListener('change', setPack));
    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const single = radios.find(r => r.value === 'single');
      if (single) {
        single.dataset.variantId = option.value;
        single.dataset.price = option.dataset.price;
        single.checked = true;
        const priceNode = $('[data-pack-price]', single.closest('.ms-pack-option'));
        if (priceNode) priceNode.textContent = format(option.dataset.price);
      }
      setPack();
    });
    setPack();
    const sticky = $('[data-sticky-purchase]');
    if (sticky && form && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        const show = !entries[0].isIntersecting && window.scrollY > 400;
        sticky.hidden = !show;
      }, { threshold: 0 });
      observer.observe(form);
    }
    $('[data-sticky-to-form]')?.addEventListener('click', () => { form.scrollIntoView({behavior: 'smooth',block:'center'}); $('[data-product-add]', form)?.focus({preventScroll:true}); });
  }

  $$('[data-compare]').forEach(container => {
    const slider = $('[data-compare-range]', container);
    slider?.addEventListener('input', () => container.style.setProperty('--split', slider.value + '%'));
  });

  // Keep accordion readable: opening one FAQ closes others in same section.
  $$('.ms-faq-list details').forEach(el => el.addEventListener('toggle', () => {
    if (!el.open) return;
    $$('.ms-faq-list details', el.closest('.ms-faq-list')).forEach(other => { if (other !== el) other.open = false; });
  }));

  // Cart count refresh is asynchronous and nonblocking.
  if ($('[data-cart-open]')) updateCart();
})();
